import { useState } from 'react';

import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { WithTestId } from 'types/app';

import type { OfferFeatureType } from '@Modules/offers/types';

import { ShowMoreButton } from '@Atomic/atoms/ShowMoreButton';

import { OfferFeature } from '../OfferFeature';

import styles from './offerFeatures.module.scss';

type Props = {
  className?: string;
  features: OfferFeatureType[];
};

const MAX_VISIBLE = 5;

export const OfferFeatures = ({ className, features, testId }: WithTestId<Props>) => {
  const [isVisible, setVisible] = useState(false);

  return (
    <div className={className} data-testid={testId}>
      <div className={styles.list}>
        {features.slice(0, isVisible ? features.length : MAX_VISIBLE).map((feature, index) => (
          <OfferFeature
            key={feature.id}
            title={feature.title}
            type={feature.type}
            values={feature.featureValues}
            testId={getTestIdByParts(testId, { value: 'item', index })}
          />
        ))}
      </div>

      {features.length > MAX_VISIBLE && (
        <ShowMoreButton
          className={styles.showMore}
          size="small"
          isToggled={isVisible}
          onClick={() => setVisible(!isVisible)}
        />
      )}
    </div>
  );
};
